"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StickyElement = /*#__PURE__*/function () {
  function StickyElement(container, page) {
    var _this = this;
    _classCallCheck(this, StickyElement);
    this.container = $(container);
    this.page = page;
    this.document = $(document);
    this.window = $(window);
    this.initialWindowHeight = this.window.outerHeight();
    this.resizedNavbarHeight = 55;
    this.resizedOffsetTop;
    this.resizeTimeout;
    this.setStickyPosition;
    this.sticky;
    this.checkResize = 0;
    this.windowScrollTop = this.window.scrollTop();
    this.styleInitial = this.page.platform.isIE() ? 'inherit' : 'initial';
    // tablet address bar height (30px)
    this.tabletCompensation = this.page.platform.isTablet() ? 30 : 0;
    this.saveInitialPosition();
    this.window.scroll(function () {
      _this.windowScrollTop = _this.window.scrollTop();
    });
    this.window.resize(function () {
      if (_this.resizeTimeout) {
        clearTimeout(_this.resizeTimeout);
      }
      _this.resizeTimeout = setTimeout(function () {
        _this.checkResize = 1;
        _this.saveInitialPosition();
        _this.setPosition();
      }, 500);
    });
    this.setPosition();
  }
  _createClass(StickyElement, [{
    key: "saveInitialPosition",
    value: function saveInitialPosition() {
      this.initialOffsetTop = this.container.offset().top - this.page.getHeaderHeight();
      this.initialSidebarHeight = this.container.height();
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      var _this2 = this;
      if (this.sticky) {
        this.sticky.destroy();
      }
      if (this.window.height() < this.initialSidebarHeight + this.page.getHeaderHeight()) {
        this.sticky = new Waypoint.Sticky({
          element: this.container,
          offset: 'bottom-in-view'
        });
        var triggerPoint;
        if (this.checkResize && this.windowScrollTop > this.initialOffsetTop) {
          triggerPoint = this.sticky.waypoint.triggerPoint;
        } else {
          triggerPoint = this.sticky.waypoint.triggerPoint - this.page.header.HEADER_COLLAPSED_DIFFERENCE;
        }
        this.setStickyPosition = function () {
          _this2.sticky.waypoint.triggerPoint = triggerPoint;
          if (_this2.document.height() - _this2.page.getFooterHeight() <= _this2.window.innerHeight() + _this2.windowScrollTop) {
            var offset = _this2.windowScrollTop + _this2.window.innerHeight() - (_this2.document.height() - _this2.page.getFooterHeight());
            _this2.sticky.element.css({
              bottom: offset,
              top: _this2.styleInitial
            });
          } else {
            _this2.sticky.element.css({
              bottom: 0,
              top: _this2.styleInitial
            });
          }
        };
        this.setStickyPosition();
        this.window.off('scroll', this.setStickyPosition);
        this.window.scroll(function () {
          _this2.setStickyPosition();
        });
      } else {
        this.sticky = new Waypoint.Sticky({
          element: this.container,
          offset: this.resizedNavbarHeight
        });
        this.resizedOffsetTop = $(this.sticky.wrapper).offset().top - this.page.getHeaderHeight();
        var resizeTimeout;
        this.window.resize(function () {
          if (resizeTimeout) {
            clearTimeout(resizeTimeout);
          }
          resizeTimeout = setTimeout(function () {
            _this2.sticky.destroy();
            _this2.sticky = new Waypoint.Sticky({
              element: _this2.container,
              offset: _this2.resizedNavbarHeight
            });
            _this2.resizedOffsetTop = $(_this2.sticky.wrapper).offset().top - _this2.page.getHeaderHeight();
            _this2.initialSidebarHeight = _this2.container.height();
            if (_this2.resizedOffsetTop < 0) {
              _this2.resizedOffsetTop = _this2.initialOffsetTop;
            }
            _this2.setStickyPosition();
          }, 500);
        });
        this.sticky.element.css({
          top: this.resizedNavbarHeight,
          bottom: this.styleInitial
        });
        this.setStickyPosition = function () {
          _this2.sticky.waypoint.triggerPoint = _this2.resizedOffsetTop;
          if (_this2.document.height() - _this2.page.getFooterHeight() <= _this2.initialSidebarHeight + _this2.page.getHeaderHeight() + _this2.windowScrollTop) {
            var compensation = _this2.initialWindowHeight < _this2.window.outerHeight() ? _this2.tabletCompensation : 0;
            var offset = _this2.windowScrollTop + _this2.window.innerHeight() - (_this2.document.height() - _this2.page.getFooterHeight());
            _this2.sticky.element.css({
              bottom: offset + compensation,
              top: _this2.styleInitial
            });
          } else {
            if (_this2.resizedOffsetTop >= _this2.initialOffsetTop) {
              if ($(window).scrollTop() >= _this2.resizedOffsetTop) {
                _this2.sticky.element.css({
                  top: _this2.resizedNavbarHeight,
                  bottom: _this2.styleInitial
                });
              } else {
                _this2.sticky.element.css({
                  top: _this2.resizedNavbarHeight,
                  bottom: _this2.styleInitial
                });
              }
            } else {
              if ($(window).scrollTop() >= _this2.resizedOffsetTop) {
                _this2.sticky.element.css({
                  top: _this2.resizedNavbarHeight,
                  bottom: _this2.styleInitial
                });
              } else {
                _this2.sticky.element.css({
                  top: _this2.resizedNavbarHeight,
                  bottom: _this2.styleInitial
                });
              }
            }
          }
        };
        this.setStickyPosition();
        this.window.off('scroll', this.setStickyPosition);
        this.window.scroll(function () {
          _this2.setStickyPosition();
        });
      }
    }
  }]);
  return StickyElement;
}();